import { AdminLayout } from "../components/admin";
import { AdminRoute } from "../components/ProtectedRoute";

export default [AdminLayout, AdminRoute];
